import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useLocation, useParams } from 'react-router'
import { RootState } from '../../../../../store/rootState'
import { ICustomizedState } from '../../../../../types/history'
import { IRouteParams } from '../../../../../types/routeParams'
import * as BudgetActions from '../../../actions/budgetCostsActions'
import * as CostsActions from '../../../actions/directAndPassTroughCosts'
import * as ProjectActions from '../../../actions/projectActions'
import { ICostSearch, ICostSorting } from '../../../types/directAndPassTroughCosts'
import { IProject } from '../../../types/project'
import ServiceProviderDirectCostsContainer from './ServiceProviderDirectCostsContainer'
import ServiceProviderExternalCostsContainer from './ServiceProviderExternalCostsContainer'
import ServiceProviderPassTroughContaner from './ServiceProviderPassTroughContaner'
import SPBudgetCategoryTabs from './ServiceProviderBudgetCategoryTabsComponent'

interface StateProps {
  project: IProject
  searchCostsValue: ICostSearch
  activeItem: string
  sortCosts: ICostSorting
}

interface DispatchProps {
  getDirectCosts: (prId: string | number, queryParams?: Record<string, string>) => void
  getPassTroughCosts: (prId: string | number, queryParams?: Record<string, string>) => void
  setActiveBudgetTab: (tab: string) => void
  getBudgetCosts: (id: string | number, queryParams?: Record<string, string>) => void
  setSortCosts: (sorting: ICostSorting) => void
  searchCosts: (filter: ICostSearch) => void
  exportProjectDirectCosts: (projectId: number, params: Record<string, string>) => void
}

type Props = StateProps & DispatchProps

export const _SPT_BUDGET_TABS = [
  { id: 1, name: 'Direct Costs', key: 'direct costs', rights: [] },
  { id: 2, name: 'Pass-Through-Costs', key: 'pass-through-costs', rights: [] },
  { id: 3, name: 'External Costs', key: 'external costs', rights: [] }
]

const ServiceProviderBudgetContainer = (props: Props): JSX.Element => {
  const {
    project,
    searchCostsValue,
    activeItem,
    sortCosts,
    getDirectCosts,
    getPassTroughCosts,
    setActiveBudgetTab,
    getBudgetCosts,
    setSortCosts,
    searchCosts,
    exportProjectDirectCosts
  } = props

  const param = useParams() as IRouteParams

  const _loc = useLocation()
  const _locState = _loc.state as ICustomizedState

  useEffect(() => {
    getDirectCosts(param.id)
    getPassTroughCosts(param.id)
  }, [getDirectCosts, getPassTroughCosts, param.id])

  useEffect(() => {
    if (_locState && _locState.tab) {
      setActiveBudgetTab(_locState.tab)
    } else {
      setActiveBudgetTab(_SPT_BUDGET_TABS[0].key)
    }
  }, [setActiveBudgetTab, param.id, _locState])

  useEffect(() => {
    const _params = project.cost_rate_billing.length !== 0 ? { project_cost_category_id: project.cost_rate_billing[0].id.toString() } : undefined
    getBudgetCosts(project.id, _params)
  }, [project, getBudgetCosts])

  const renderSPBudgetCategoryTabs = (): JSX.Element => {
    return (
      <SPBudgetCategoryTabs
        project={project}
        activeItem={activeItem}
        searchCostsValue={searchCostsValue}
        sortCosts={sortCosts}
        searchCosts={searchCosts}
        setActiveBudgetTab={setActiveBudgetTab}
        exportProjectDirectCosts={exportProjectDirectCosts}
        setSortCosts={setSortCosts}
      />
    )
  }

  const renderTables = (): JSX.Element | null => {
    switch (activeItem) {
      case 'direct costs':
        return <div style={{ paddingTop: 0 }}><ServiceProviderDirectCostsContainer /></div>

      case 'pass-through-costs':
        return <div style={{ paddingTop: 0 }}><ServiceProviderPassTroughContaner /></div>

      case 'external costs':
        return <div style={{ paddingTop: 0 }}><ServiceProviderExternalCostsContainer /></div>

      default:
        return null
    }
  }

  return (
    <div>
      <div>
        {renderSPBudgetCategoryTabs()}
      </div>
      <div id='project-budget'>
        {renderTables()}
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState): StateProps => {
  return {
    project: state.projectsState.project,
    searchCostsValue: state.projectsState.searchCosts,
    activeItem: state.projectsState.activeSPTBudgetTab,
    sortCosts: state.projectsState.sortCosts
  }
}

const mapDispatchToProps = (
  dispatch:
    CostsActions.DirectAndPassTroughCostThunkDispatchType &
    BudgetActions.BudgetCostsThunkDispatchType &
    ProjectActions.ProjectThunkDispatchType
): DispatchProps => {
  return {
    getDirectCosts: (prId, queryParams) => dispatch(CostsActions.getDirectCosts(prId, queryParams)),
    getPassTroughCosts: (prId, queryParams) => dispatch(CostsActions.getPassTroughCosts(prId, queryParams)),
    setActiveBudgetTab: (tab) => dispatch(CostsActions.setActiveSPTBudgetTab(tab)),
    getBudgetCosts: (prId, queryParams) => dispatch(BudgetActions.getBudgetCosts(prId, queryParams)),
    setSortCosts: sorting => dispatch(CostsActions.sortCosts(sorting)),
    searchCosts: filter => dispatch(CostsActions.searchCosts(filter)),
    exportProjectDirectCosts: (projectId, params) => dispatch(ProjectActions.exportProjectDirectCosts(projectId, params)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ServiceProviderBudgetContainer)
